import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addTrain from "./component/addTrain.vue";
import SignUpStudentList from './component/signUpStudentList.vue';
export default {
  name: "trainmanage",
  components: {
    addTrain: addTrain,
    SignUpStudentList: SignUpStudentList
  },
  mixins: [loadMoreList, commonData],
  props: ['teamId'],
  data: function data() {
    return {
      paramsData: {
        status: ''
      },
      tableData: [],
      total: 0,
      statusList: [{
        label: '未开始',
        value: "0"
      }, {
        label: '进行中',
        value: "1"
      }, {
        label: '已结束',
        value: "2"
      }, {
        label: '已取消',
        value: "3"
      }]
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.trainingsList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  team_id: _this.teamId
                })).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      if (item.description) {
                        var description = JSON.parse(item.description);
                        item.note = description.note;
                        item.content_text = description.content_text;
                      }
                    });
                    _this.tableData = data;
                    _this.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleCancle: function handleCancle(id) {
      var _this2 = this;

      this.$confirm("此操作将取消该训练, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.trainingsCancel({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.$message.success("取消成功!");

                    _this2.getList(_this2.paramsData.page);
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该训练, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$api.trainingsDel({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("删除成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};